@if (processView$ | async; as processView) {
	@if (processView.feedback?.systemType === "CREATE_TICKET") {
		<stages-feedback-widget />
	}
	@if (processView.feedback?.systemType === "CREATE_TICKET_LINK") {
		<stages-feedback-link-widget />
	}
}
